import { useIsFoundationalPillarsNavPhase1Enabled } from '@ms/yammer-features-app-navigation';
import { useIsNetworkQuestionsEnabledAndLicensed } from '@ms/yammer-hooks/dist/networkQuestions';
import {
  VivaEngageNavigationHeaderPivotItem,
  useCommunitiesPivotItem,
  useHomePivotItem,
  useLeadershipCornerPivotItem,
  useQnAPivotItem,
  useStorylinesPivotItem,
} from '@ms/yammer-web-components/dist/teams/VivaEngageNavigationHeaderPivot';
import { useUIFeatures } from '@ms/yammer-web-ui-features/dist/features';
import { useMemo } from 'react';

export const useGetNavigationHeaderPivotItems: () => VivaEngageNavigationHeaderPivotItem[] = () => {
  const features = useUIFeatures(({ navigation }) => navigation ?? {});
  const isNetworkQuestionsEnabledAndLicensed = useIsNetworkQuestionsEnabledAndLicensed();
  const isFoundationalPillarsNavPhase1Enabled = useIsFoundationalPillarsNavPhase1Enabled();

  const homePivotItem = useHomePivotItem();
  const communitiesPivotItem = useCommunitiesPivotItem();
  const storylinesPivotItem = useStorylinesPivotItem();
  const qnAPivotItem = useQnAPivotItem();
  const leadershipCornerPivotItem = useLeadershipCornerPivotItem();

  return useMemo(
    () =>
      isFoundationalPillarsNavPhase1Enabled
        ? []
        : [
            features.homeFeed ? homePivotItem : null,
            features.groups ? communitiesPivotItem : null,
            features.storylines ? storylinesPivotItem : null,
            features.leadershipCorner ? leadershipCornerPivotItem : null,
            features.questions && isNetworkQuestionsEnabledAndLicensed ? qnAPivotItem : null,
          ].filter<VivaEngageNavigationHeaderPivotItem>(
            (item): item is VivaEngageNavigationHeaderPivotItem => item != null
          ),
    [
      features,
      homePivotItem,
      communitiesPivotItem,
      storylinesPivotItem,
      leadershipCornerPivotItem,
      qnAPivotItem,
      isNetworkQuestionsEnabledAndLicensed,
      isFoundationalPillarsNavPhase1Enabled,
    ]
  );
};
